import './context-menu-modal.scss';

import { faBroadcastTower, faEraser, faFlag, faFlagUsa } from '@fortawesome/free-solid-svg-icons';
import { BModal } from 'bootstrap-vue';
import { Component } from 'vue-property-decorator';

import { IndexedDBCache } from '@skinsoft/offline';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { ForceSwReloadModal } from '@skinsoft/offline-mode'

declare var COMMIT_HASH: string;
declare var BRANCH: string;
declare var BUILD_ISO_DATE: string;
declare var VERSION: string;

@Component({
    template: require('./context-menu-modal.html'),
    components: {
        sForceSwReloadModal: ForceSwReloadModal,
    }
})
export class ContextMenuModal extends ReactiveVue {
    public broadcastTowerIcon = faBroadcastTower;
    public eraserIcon = faEraser;
    public flagIcon = faFlag;
    public flagUsaIcon = faFlagUsa;

    public $refs: {
        modal: BModal,
        swModal: ForceSwReloadModal,
    };
    public branch = BRANCH;
    public buildDate = new Date(BUILD_ISO_DATE);
    public commitHash = COMMIT_HASH;
    public version = VERSION;

    public isLocaleOverriden() {
        return !!window.localStorage.getItem('locale');
    }

    public close() {
        this.$refs.modal.hide();
    }

    public open() {
        this.$refs.modal.show();
    }

    public checkForUpdate() {
        this.emitOnBus('check_for_update_topic');
        this.close();
    }

    public async clearCache() {
        await IndexedDBCache.clearStorage();
        this.close();
    }

    public async overrideLocaleWithEnglish() {
        window.localStorage.setItem('locale', 'en');
        // @ts-ignore
        window.location.reload(true);
    }

    public async resetLocaleOverride() {
        window.localStorage.removeItem('locale');
        // @ts-ignore
        window.location.reload(true);
    }

    private openSwReloadModal () {
        this.$refs.swModal.openModal()
    }
}
